import { render, staticRenderFns } from "./AcknowledgeMessagesAdd.vue?vue&type=template&id=1fb8e563&scoped=true&"
import script from "./AcknowledgeMessagesAdd.vue?vue&type=script&lang=js&"
export * from "./AcknowledgeMessagesAdd.vue?vue&type=script&lang=js&"
import style0 from "./AcknowledgeMessagesAdd.vue?vue&type=style&index=0&id=1fb8e563&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb8e563",
  null
  
)

export default component.exports